import React, { useEffect, useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { BiomarkLogo, BiomarkText } from '../../../../assets/Images';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { loginPageStyles } from '../../../../styles';
import { toast } from 'material-react-toastify';
import {
  setCheckInId,
  updatePracticeStatus,
} from '../../../../redux/features/Practice';
import {
  Box,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Typography,
  CssBaseline,
} from '@mui/material';
import {
  PopupForBlockedAccount,
  InActiveAccountPopup,
  InvalidLoginDialog,
} from '../../Popups';
import {
  authenticateUser,
  setError,
  unlockAccount,
} from '../../../../redux/features/User';
import { Loader, Toast as CustomToast } from '../../../../Components';
import { isMalaysian } from '../../../../utils';

const LoginScreen = () => {
  const search = useLocation().search;
  const checkInId = useSelector((state) => state.practicesReducer.checkInId);
  const unlock_token = new URLSearchParams(search).get('unlock_token');

  const classes = loginPageStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [invalidCreds, setInvalidCreds] = React.useState(false);
  const [maxLimitReached, setMaxLimitReached] = React.useState(false);
  const [isActive, setIsActive] = React.useState(true);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const loading = useSelector((state) => state.userReducer.loading);
  const [loginInfo, setLoginInfo] = useState({
    userName: null,
    password: null,
  });

  // Styles Definition Here
  const titleStyle = {
    fontFamily: 'Mukta',
    fontSize: '21px',
    lineHeight: '27px',
    fontWeight: '700',
    color: '#2A3752',
  };
  const textStyle = {
    fontFamily: 'Mulish',
    fontSize: '13px',
    lineHeight: '16px',
    textTransform: 'none',
  };

  const errorStyle = { ...textStyle, fontSize: '12px' };

  useEffect(() => {
    if (unlock_token) {
      dispatch(unlockAccount({ unlock_token: unlock_token }))
        .unwrap()
        .then(() => {})
        .catch(() => {
          toast(
            <CustomToast
              severity="warning"
              message="Sorry, this link is no longer valid"
            />,
            { closeButton: false }
          );
        });
    }
  }, []);

  // Handlers Here
  const loginHandler = async () => {
    if (
      (loginInfo.userName == null && loginInfo.password == null) ||
      (loginInfo.userName === '' && loginInfo.password === '')
    ) {
      setLoginInfo({ userName: '', password: '' });
      dispatch(setError('Please Enter Email Address and Password.'));
    } else if (loginInfo.password === '' || loginInfo.password == null) {
      setLoginInfo({ userName: loginInfo.userName, password: '' });
    } else if (loginInfo.userName === '' || loginInfo.userName == null) {
      setLoginInfo({ userName: '', password: loginInfo.password });
      dispatch(setError('Please Enter Email Address.'));
    }
    if (!!loginInfo.userName && !!loginInfo.password) {
      const data = JSON.stringify({
        rider: { staff_id: loginInfo.userName, password: loginInfo.password },
      });

      dispatch(authenticateUser(data))
        .unwrap()
        .then((res) => {
          navigator.serviceWorker.controller?.postMessage({
            type: 'MESSAGE_IDENTIFIER',
            user: res.data,
          });

          /*
           * Now we will send another message for
           * checking pending notifications
           */
          navigator.serviceWorker.controller?.postMessage({
            type: 'PENDING_NOTIFICATIONS',
          });
          // }

          if (isMalaysian(res?.data?.country)) {
            navigator.serviceWorker.controller?.postMessage({
              type: 'login',
            });
          } else {
            const payload = {
              userId: res.data?.id,
              order: {
                old_status: 'arrived',
              },
              riders: {
                status: 'en-route',
              },
            };
            dispatch(updatePracticeStatus(payload))
              .unwrap()
              .then(() => {
                if (checkInId) {
                  dispatch(setCheckInId(0));
                }
                /*
                Now we will send message to each tab for reload
                as user is authenticated now
              */
                navigator.serviceWorker.controller?.postMessage({
                  type: 'login',
                });
              })
              .catch((err) => {
                toast(
                  <CustomToast severity="warning" message={err.message} />,
                  {
                    closeButton: false,
                  }
                );
              });
          }
        })
        .catch((err) => {
          if (err === 'Invalid Staff or password.') {
            setInvalidCreds(true);
          } else if (err === 'Your account is not activated yet.') {
            setIsActive(false);
          } else if (err === 'Your account is locked.') {
            setMaxLimitReached(true);
          }
        });
    }
  };
  const onChangeHandler = (e) => {
    setLoginInfo({ ...loginInfo, userName: e.target.value });
  };

  const onPasswordChangeHandler = (e) => {
    setLoginInfo({ ...loginInfo, password: e.target.value });
  };
  const handleClickShowNewPassword = () => {
    setNewPasswordVisible((previousValue) => !previousValue);
  };
  const forgot_password = () => {
    navigate('/forgot_password');
  };

  // We want to make sure if there is token we should navigate user to logistics screen instead login
  React.useEffect(() => {
    if (localStorage.getItem('authToken')) navigate('/logistics');
  }, []);

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '100vh',
          m: 'auto 27.5px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            maxWidth: '320px',
            m: 'auto',
          }}
        >
          <Box sx={{ mb: '1rem' }}>
            <img src={BiomarkLogo} alt="" />{' '}
          </Box>
          <Box sx={{ mb: '10px' }}>
            <img src={BiomarkText} alt="" />{' '}
          </Box>
          <Box
            sx={{ height: '39px', mb: '10px', textAlign: 'center' }}
            style={titleStyle}
          >
            Lab Dispatch App
          </Box>

          <Box sx={{ width: 'inherit' }}>
            <Box style={textStyle} sx={{ color: '#455066', mb: '4px' }}>
              Staff ID
              <Typography variant="span" sx={{ ml: '2px', color: '#EA4C59' }}>
                <strong>*</strong>
              </Typography>
            </Box>
            <TextField
              fullWidth
              error={loginInfo?.userName === '' ? true : false}
              helperText={
                loginInfo?.userName != null && loginInfo?.userName === ''
                  ? '* Staff ID Required'
                  : ' '
              }
              type="text"
              placeholder="Staff ID"
              value={loginInfo.userName ?? ''}
              className={classes.textField}
              name="username"
              onChange={(e) => onChangeHandler(e)}
              sx={{
                '& .MuiInputBase-input': {
                  py: '11.5px',
                  height: 'auto',
                },
              }}
              FormHelperTextProps={{
                sx: errorStyle,
              }}
            />
            <Box style={textStyle} sx={{ color: '#455066', mb: '4px' }}>
              Password
              <Typography variant="span" sx={{ ml: '2px', color: '#EA4C59' }}>
                <strong>*</strong>
              </Typography>
            </Box>
            <TextField
              fullWidth
              error={loginInfo?.password === '' ? true : false}
              type={newPasswordVisible ? 'text' : 'password'}
              helperText={
                loginInfo?.password != null && loginInfo?.password === ''
                  ? '* Password Required'
                  : ' '
              }
              placeholder="Password"
              value={loginInfo.password ?? ''}
              className={classes.textField}
              name="password"
              onChange={(e) => onPasswordChangeHandler(e)}
              sx={{
                '& .MuiInputBase-input': {
                  py: '11.5px',
                  height: 'auto',
                },
              }}
              FormHelperTextProps={{
                sx: errorStyle,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={handleClickShowNewPassword}
                      edge="end"
                    >
                      {newPasswordVisible ? (
                        <Visibility
                          sx={{
                            width: '21px',
                            color: '#8493AE',
                          }}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{
                            width: '21px',
                            color: '#8493AE',
                          }}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box sx={{ mb: '14px', textAlign: 'center' }}>
            <Button
              onClick={forgot_password}
              variant="text"
              sx={{
                textAlign: 'center',
                color: '#054E8B',
                backgroundColor: '054E8B',
                ':hover': {
                  bgcolor: '#ffffff',
                },
              }}
            >
              <Box style={textStyle}>Forgot password?</Box>
            </Button>
          </Box>
          <Button
            onClick={() => loginHandler()}
            variant="text"
            className={classes.buttonStyle}
            sx={{
              bgcolor: '#054E8B',
              textTransform: 'none',

              py: '9px',
              height: '40px',
              ':hover': { bgcolor: '#054E8B' },
            }}
          >
            {' '}
            Login
          </Button>
          {loading ? (
            <Loader loading={loading} />
          ) : (
            <>
              {invalidCreds && <InvalidLoginDialog setOpen={setInvalidCreds} />}
              {maxLimitReached && (
                <PopupForBlockedAccount setOpens={setMaxLimitReached} />
              )}
              {!isActive && <InActiveAccountPopup setOpens={setIsActive} />}
            </>
          )}
        </Box>
        <Box style={textStyle} sx={{ color: '#8493AE', my: 'auto' }}>
          Version X.X
        </Box>
      </Box>
    </>
  );
};

export default LoginScreen;
